export const SUPPORTED_LOCALES = ["en", "nl"];

export const DEFAULT_SITE_COPY = {
  navHome: "Home",
  navAbout: "About",
  navResume: "Resume",
  navContact: "Contact",
  downloadCvLabel: "Download CV",
  homeHeadline: "clint sarijan siadis",
};

export function isSupportedLocale(locale) {
  return SUPPORTED_LOCALES.includes(locale);
}

/** Current path is `/:locale/...`; return same path with a different locale prefix. */
export function swapLocaleInPath(pathname, newLocale) {
  const segments = pathname.split("/").filter(Boolean);
  const tail = segments.slice(1);
  if (!tail.length) return `/${newLocale}`;
  return `/${newLocale}/${tail.join("/")}`;
}
